'use client';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@/primitives';

type Props = {
  open: boolean;
  onClose: () => void;
};

export default function BasicSearchPercentileInfoDialog({
  open,
  onClose,
}: Props) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>BREEDPLAN percentiles in Basic Search</DialogTitle>
      <DialogContent>
        <Typography variant="bodymedium" sx={{ mb: 2 }}>
          A BREEDPLAN percentile shows how an animal&apos;s genetic performance
          for a trait ranks relative to the rest of the breed. To find animals
          in the Top X% of the breed, enter the desired value into the{' '}
          <strong>Min %</strong> field; this will return all animals ranked at
          or better than that percentile.
        </Typography>
        <Typography variant="bodymedium">
          For traits where an optimal range may be more desirable (e.g. Milk),
          you can search within a specific percentile band. For example, to find
          animals between the 40th and 60th percentiles, enter 40 into{' '}
          <strong>Min %</strong> and 60 into <strong>Max %</strong>, which
          together define an inclusive range.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="outlined" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
